__turbopack_context__.v({
  "accordianContainer": "_5Q-vOa_accordianContainer",
  "buttonFocused": "_5Q-vOa_buttonFocused",
  "hoverEnabled": "_5Q-vOa_hoverEnabled",
});
